// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delete-account{margin:10px;padding:15px;border-radius:5px;background:#fff}.delete-account__email{padding:20px 0 20px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
